import React, { useState } from "react";
import "./socialMediaBox.scss";
import {
  facebookIcon,
  instaIcon,
  instaIconHover,
  youtubeIcon,
} from "../../source";

const SocialMediaBox = ({ title, desc, instaLink, fbLink, ytLink }) => {
  const [hover, setHover] = useState(false);

  return (
    <>
      <div className="my_container">
        <div className="social_media_container">
          <div className="social_content">
            <h2 className="title">{title}</h2>
            <p className="desc">{desc}</p>
            <div className="social_icon_wrap">
              {instaLink && (
                <a
                  href={instaLink}
                  target="_blank"
                  rel="noreferrer"
                  className="social_link"
                  onMouseOver={()=>setHover(true)}
                  onMouseOut={()=>setHover(false)}
                >
                  <img
                    src={hover ? instaIconHover : instaIcon}
                    alt="instagram"
                    className="social_icon"
                  />
                </a>
              )}
              {fbLink && (
                <a
                  href={fbLink}
                  target="_blank"
                  rel="noreferrer"
                  className="social_link"
                                  >
                  <img
                    src={facebookIcon}
                    alt="youtube"
                    className="social_icon"
                  />
                </a>
              )}
              {ytLink && (
                <a
                  href={ytLink}
                  target="_blank"
                  rel="noreferrer"
                  className="social_link"
                >
                  <img
                    src={youtubeIcon}
                    alt="facebook"
                    className="social_icon"
                  />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SocialMediaBox;
